import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperArrow } from './testimonialParts';
export function Timeline(_a) {
    var items = _a.items;
    var _b = React.useState(0), activeIndex = _b[0], updateIndex = _b[1];
    var breakpoints = {
        0: {
            slidesPerView: 1
        },
        800: {
            slidesPerView: 2
        },
        1200: {
            slidesPerView: 3
        }
    };
    var viewBoundrary = function () {
        if (window.innerWidth <= 800) {
            return 0;
        }
        if (window.innerWidth <= 1200) {
            return 1;
        }
        return 2;
    };
    return (React.createElement("div", { className: 'timeline-slideshow' },
        React.createElement(Swiper, { onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); }, breakpoints: breakpoints },
            items.map(function (item, index) {
                return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1), className: activeIndex + viewBoundrary() >= index &&
                        activeIndex + viewBoundrary() <= index + viewBoundrary()
                        ? 'in-view'
                        : 'outside-view' },
                    React.createElement(TimelineSlide, { item: item, activeIndex: activeIndex, even: index % 2 === 0 }));
            }),
            React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.length, direction: 'left' }),
            React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.length, direction: 'right' }))));
}
function TimelineSlide(props) {
    var date = new Date(props.item.year);
    return (React.createElement("div", { className: 'timeline-slide-item' },
        React.createElement("div", { className: "content-box ".concat(props.even ? 'even' : 'odd'), dangerouslySetInnerHTML: { __html: props.item.content } }),
        React.createElement("div", { className: 'timeline-year' }, date.getFullYear()),
        React.createElement("div", { className: "content-box ".concat(props.even ? 'even' : 'odd'), dangerouslySetInnerHTML: { __html: props.item.content } })));
}
